export default "/static/b036e776f9e5b93c.png"